import I18n from '../../config/locales';

export const ACCOUNT_DETAIL_REQUEST = 'ACCOUNT_DETAIL_REQUEST';
export const ACCOUNT_DETAIL_SUCCESS = 'ACCOUNT_DETAIL_SUCCESS';
export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESEND_CONFIRMATION_EMAIL_REQUEST = 'RESEND_CONFIRMATION_EMAIL_REQUEST';
export const RESEND_CONFIRMATION_EMAIL_SUCCESS = 'RESEND_CONFIRMATION_EMAIL_SUCCESS';
export const CANCEL_EMAIL_CHANGE_REQUEST = 'CANCEL_EMAIL_CHANGE_REQUEST';
export const CANCEL_EMAIL_CHANGE_SUCCESS = 'CANCEL_EMAIL_CHANGE_SUCCESS';
export const UPDATE_ACCOUNT_SUCCESS = 'UPDATE_ACCOUNT_SUCCESS';
export const REQUEST_FAILURE = 'REQUEST_FAILURE';
export const SET_LOCALE_REQUEST = 'SET_LOCALE_REQUEST';
export const REQUEST_TRAINING_DASHBOARD_TOKEN = 'REQUEST_TRAINING_DASHBOARD_TOKEN';
export const SET_TRAINING_DASHBOARD_TOKEN = 'SET_TRAINING_DASHBOARD_TOKEN';
export const GET_FLEET_DASHBOARD_LINK = 'GET_FLEET_DASHBOARD_LINK';
export const SET_FLEET_DASHBOARD_LINK = 'SET_FLEET_DASHBOARD_LINK';
export const FIELD_REQUIRED = I18n.t('users.fieldRequired');
export const VALID_EMAIL = I18n.t('users.validEmail');
export const EMAIL_MATCH = I18n.t('users.emailMatch');
export const VALID_PHONE = I18n.t('company.validPhone');

export const GENERATE_API_KEY_REQUEST = 'GENERATE_API_KEY_REQUEST';
export const GENERATE_API_KEY_SUCCESS = 'GENERATE_API_KEY_SUCCESS';
export const GENERATE_API_KEY_FAILURE = 'GENERATE_API_KEY_FAILURE';

export const GET_API_KEY_REQUEST = 'GET_API_KEY_REQUEST';
export const GET_API_KEY_SUCCESS = 'GET_API_KEY_SUCCESS';

export const GET_JOB_PROFILE_REQUEST = 'GET_JOB_PROFILE_REQUEST';
export const GET_JOB_PROFILE_SUCCESS = 'GET_JOB_PROFILE_SUCCESS';
export const GET_JOB_PROFILE_FAILURE = 'GET_JOB_PROFILE_FAILURE';
